import { AuthApi } from '@linktivity/triplabo-taxi';

import config from '../config';

const auth = new AuthApi(config);

export default auth;
